// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true,"publicPath":"../../"}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3c94be37","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/comps/c2_info/01_list.vue
// module id = xpWQ
// module chunks = 1